import type { Role } from '@shared/user';

export const ROLE_LABEL: Record<Role, string> = {
  owner: 'Owner',
  admin: 'Admin',
  agent: 'Agent',
  billing: 'Billing',
};

export const ROLE_ORDER: readonly Role[] = ['owner', 'admin', 'billing', 'agent'];
